// extracted by mini-css-extract-plugin
module.exports = {"invisible":"Stats_invisible__3VoKo","container":"Stats_container__21tp5","btn":"Stats_btn__f2CEP"};